import { of, empty, Observable } from 'rxjs';

import { tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { LunaDomain} from "../models/domain.model";
import { CacheService, MemoryCache } from '../../common/services/cache-service';
import { CasingTypeModel, DrillingEquipmentModel, FormationModel } from "../../form-controls/components/new-casing-plan/models/casing-plan.model";


@Injectable()
export class DomainDefinitionService {

    public _domainCache: CacheService = new MemoryCache('domains');
    public _domainsCache: CacheService = new MemoryCache("allDomains");
    public _statesDomain = 'STATE';

  constructor(public http: HttpClient) { }

  get(id: string): Observable<LunaDomain> {
    if (!id)
      return empty();

    if (this._domainCache.has(id))
      return of(this._domainCache.get<LunaDomain>(id));
    else
      return this.http.get<LunaDomain>(`/api/domain/${id}`).pipe(tap(x => this._domainCache.set(id, x)));
  }


  getAll(): Observable<LunaDomain[]> {
      if (this._domainsCache.has('*'))
          return of(this._domainsCache.get<LunaDomain[]>('*'));
      else
          return this.http.get<LunaDomain[]>(`/api/domain`);//.do(x => this._domainsCache.set('*', x));
  }

  getStates(): Observable<LunaDomain> {
    return this.get(this._statesDomain);
  }

  post(body: LunaDomain): Observable<LunaDomain> {
    return this.http.post<LunaDomain>(`/api/domain/${body.id}`, body);
  }

  delete(id: string) {
    return this.http.delete(`/api/domain/${id}`);
    }

    getValues(id: string): Observable<any> {
        if (!id) return empty();
        if (this._domainCache.has(id)) {
            return of(this._domainCache.get<LunaDomain>(id).values);
        } else {
            return this.http.get<any>(`/api/domain/values/${id}`);
        }
    }

    getCasingStrings(): Observable<CasingTypeModel[]> {
        return this.getValues("CSG_STRING").pipe(
            map((casings: any[]) => {
                let models: CasingTypeModel[] = [];
                if (casings != null) {
                    casings.forEach(c => {
                        const model = new CasingTypeModel();
                        model.code = c.Code;
                        model.definition = (c.Code !== 'HOL1') ? c.Definition : 'Open Hole';
                        model.isActive = c.isActive;
                        model.isRequired = c.isRequired;
                        model.lastModifiedDateUTC = c.LastModifiedDateUTC;
                        models.push(model);
                    });
                }
                return models;
            }));
    }

    getDrillingEquipment(): Observable<DrillingEquipmentModel[]> {
        return this.getValues("RIG_TYP").pipe(
            map((equipment: any[]) => {
                let models: DrillingEquipmentModel[] = [];
                if (equipment != null) {
                    equipment.forEach(f => {
                        const model = new DrillingEquipmentModel();
                        model.code = f.Code;
                        model.definition = f.Definition;
                        model.isActive = f.isActive;
                        model.isRequired = f.isRequired;
                        model.lastModifiedDateUTC = f.LastModifiedDateUTC;
                        models.push(model);
                    });
                }
                return models;
            }
            ));
    }

    getFormations(): Observable<FormationModel[]> {
        return this.getValues("FORMATION").pipe(
            map((formations: any[]) => {
                let models: FormationModel[] = [];
                if (formations != null) {
                    formations.forEach(f => {
                        const model = new FormationModel();
                        model.code = f.Code;
                        model.definition = f.Definition;
                        model.isActive = f.isActive;
                        model.isRequired = f.isRequired;
						model.lastModifiedDateUTC = f.LastModifiedDateUTC;
						model.aapgCode = f.aapgCode;
                        models.push(model);
                    });
                }
                return models;
            }
            ));
    }
}
